import { Injectable } from '@angular/core';
import { TrendencyReqService } from '@trendency/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class NationalHolidayDetailService {
  constructor(private readonly reqService: TrendencyReqService) {}

  getNationalHolidayDetail$(nationalHolidaySlug: string): Observable<any> {
    return this.reqService.get(`national-holiday/${nationalHolidaySlug}`).pipe(map((data: any) => data.data));
  }
}
